import { faClockRotateLeft } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useHseSummary } from "@dashboard/hooks/useHseSummary";
import { StatCard } from "./StatCard";

export default function OverdueIssues() {
    const { t } = useTranslation();
    const { data: summary, isPending, isError } = useHseSummary();

    const linkHref = summary && !Array.isArray(summary.links) ? summary.links.issues : undefined;

    return (
        <StatCard
            label={t("dashboard.overdueIssues")}
            value={summary?.metrics.issues.overdue}
            isPending={isPending}
            isError={isError}
            icon={faClockRotateLeft}
            variant="yellow"
            linkHref={linkHref}
            linkLabel={t("dashboard.manageIssues")}
        />
    );
}
